"use client";

import * as React from "react";
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Stack, Grid, TextField, MenuItem,
    Button
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CtaButton from "../buttonWithArrow";
import DynamicPillButton from "../buttonWithArrow/whatsappButton";
import { lockScroll, unlockScroll } from '../../utils/scrollLock'
import { openWhatsAppChat, openWhatsAppChatForTravelAndTourism } from "../../utils/onWhatsApp";

// ---------- styles ----------
const modalSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    p: 2,
};

const sheetSx = {
    position: "relative",
    width: 800,
    maxWidth: "94vw",
    bgcolor: "#fff",
    borderRadius: 4,
    p: { xs: 3, sm: 4 },
    boxShadow: "0 18px 60px rgba(0,0,0,.25)",
};

const sheetSxNew = {
    position: "relative",
    width: 500,
    maxWidth: "92vw",
    bgcolor: "#fff",
    borderRadius: 4, // ~16px
    p: 3,
    boxShadow: "0 18px 60px rgba(0,0,0,.25)",
};

const titleSx = {
    fontWeight: 800,
    fontSize: 22,
    textAlign: "center",
    mb: 1,
};

const subtitleSx = {
    fontSize: 15,
    textAlign: "center",
    color: "text.secondary",
    mb: 3,
};

const closeBtnSx = {
    position: "absolute",
    top: 12,
    right: 12,
    cursor: "pointer",
};

const formWrapperSx = {
    border: "1px solid #E5E7EB",
    borderRadius: 3,
    p: 4,
    mb: 3,
};

// custom TextField style
const textFieldSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: "50px",
        height: 48,
        backgroundColor: "#fff",
    },
    "& .MuiInputLabel-root": {
        top: -5,
        fontSize: 14,
        fontWeight: 600,
    },
};

const bgcolor = "#fff"
const borderColor = "#E3E6EB";

// gradient outline pill (selected)
const tileSelectedSx = {
    borderRadius: 3,
    height: 72,
    px: 2,
    textTransform: "none",
    fontWeight: 800,
    fontSize: 18,
    color: "#0D8196",
    border: "2px solid transparent",
    background:
        "linear-gradient(#fff,#fff) padding-box, linear-gradient(135deg,#81D0D5,#0D8196) border-box",
};

// disabled grey tile
const tileDisabledSx = {
    borderRadius: 3,
    height: 72,
    px: 2,
    textTransform: "none",
    fontWeight: 800,
    fontSize: 18,
    bgcolor: "#F4F5F6",
    border: "1px solid #E5E7EB",
    color: "#A3A7AD",
    "&.Mui-disabled": {
        bgcolor: "#F4F5F6",
        borderColor: "#E5E7EB",
        color: "#A3A7AD",
        opacity: 1, // keep text readable when disabled
    },
};


export default function InvestmentCalculatorModal({
    open,
    handleClose,
    onSubmit, options, setJetOption, jetOption, onOrderNow, datas
}) {
    const [step, setStep] = React.useState("option");
    const [rows, setRows] = React.useState([]);
    const [form, setForm] = React.useState({
        year: "",
        brand: "",
        condition: "",
        driver: "",
    });

    React.useEffect(() => {
        if (datas) {
            setForm((prev) =>
            ({
                ...prev,
                year: datas?.year?.[0],
                brand: datas?.brand?.[0]?.label,
                condition: datas?.condition?.[0]?.label,
                driver: datas?.driver?.[0]?.label,
            })
            );
        }
    }, [datas])

    const resetData = () => {
        setStep("option")
        setJetOption("INVESTOR");
        setForm((prev) =>
        ({
            ...prev,
            year: datas?.year?.[0],
            brand: datas?.brand?.[0]?.label,
            condition: datas?.condition?.[0]?.label,
            driver: datas?.driver?.[0]?.label,
        })
        );
    }

    React.useEffect(() => {
        if (options) {
            const data = options?.filter((item) => item.value === jetOption);
            setRows(data?.[0]?.data?.roiInvestorBenefitsNew?.rows)
        }
    }, [options, jetOption])

    React.useEffect(() => {
        if (open) lockScroll();
        else unlockScroll();

        return () => unlockScroll(); // cleanup if component unmounts
    }, [open]);

    const handleSubmit = () => {
        // Here you can also run API call or calculation logic
        setStep("result");
    };


    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
    };

    const getLabel = () => {
        const data = options?.filter((item) => item.value === jetOption);
        return data?.[0]?.label
    }

    return (
        <Modal open={open} onClose={handleClose} sx={modalSx}>
            <Box sx={step === "option" ? sheetSxNew : sheetSx}>
                {/* Close button */}
                <IconButton onClick={() => {
                    resetData();
                    handleClose();
                }} sx={closeBtnSx}>
                    <HighlightOffIcon />
                </IconButton>

                {step === "option" && (
                    <Box>
                        <Typography
                            className="jura"
                            sx={{ ...titleSx, fontSize: 24, fontWeight: 800 }}
                        >
                            Please Select An Option
                        </Typography>


                        <IconButton onClick={handleClose} sx={closeBtnSx}>
                            <HighlightOffIcon />
                        </IconButton>

                        <Stack spacing={1.5} sx={{ mt: 2 }}>
                            {
                                options?.map((item, index) => (
                                    <Button key={index}
                                        style={{ display: "flex", flexDirection: "column", fontSize: '24px', height: "100px" }}
                                        fullWidth
                                        onClick={() => {
                                            setJetOption(item?.value);
                                            setStep("form");
                                        }} sx={item?.value === jetOption ? tileSelectedSx : tileDisabledSx}>
                                        {item?.label}
                                        <span style={{ fontSize: "16px", color: "#a7a6a6" }}>{item?.description}</span>
                                    </Button>
                                ))
                            }
                        </Stack>

                        <Stack
                            direction="row"
                            spacing={1.5}
                            justifyContent="center"
                            sx={{ mt: 2.5, flexDirection: { xs: "row", sm: "row" } }}
                        >
                            <Box>
                                <DynamicPillButton
                                    label="Send a message"
                                    icon="/img/header/whatsapp.svg"
                                    iconPosition="end"
                                    bg="#25D366"
                                    onClick={() => openWhatsAppChat(`${getLabel()}(Travel & Tourism)`, "investing")}
                                    size="md"
                                    sx={{ height: "100% !important", minHeight: "50px", fontSize: { xs: "14px", sm: "auto" } }}
                                />
                            </Box>

                            {/* <CtaButton label="Continue" onClick={onOrderNow} sx={{ fontSize: { xs: "14px", sm: "auto" } }} /> */}
                        </Stack>
                    </Box>
                )}

                {step === "form" && (
                    <>
                        {/* Title */}
                        <Typography className="jura" sx={titleSx}>
                            Investment calculator simulator
                        </Typography>
                        <Typography sx={subtitleSx}>
                            Enter your vehicle information and check if it is eligible to work
                            with us
                        </Typography>

                        {/* Form inside bordered wrapper */}
                        <Box sx={formWrapperSx}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography sx={{ fontWeight: 500, mb: 0.75 }}>Year</Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        // label="Year"
                                        value={form.year}
                                        onChange={(e) => handleChange("year", e.target.value)}
                                        sx={textFieldSx}
                                    >
                                        {datas?.year?.map((year, inx) => (
                                            <MenuItem key={inx} value={year}>
                                                {year}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography sx={{ fontWeight: 500, mb: 0.75 }}>Brand</Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        // label="Brand"
                                        value={form.brand}
                                        onChange={(e) => handleChange("brand", e.target.value)}
                                        sx={textFieldSx}
                                    >
                                        {datas?.brand?.map((brand, inx) => (
                                            <MenuItem key={inx} value={brand?.label}>
                                                {brand?.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography sx={{ fontWeight: 500, mb: 0.75 }}>Condition</Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        // label="Condition"
                                        value={form.condition}
                                        onChange={(e) => handleChange("condition", e.target.value)}
                                        sx={textFieldSx}
                                    >
                                        {datas?.condition?.map((condition, inx) => (
                                            <MenuItem key={inx} value={condition?.label}>
                                                {condition?.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12} sm={6} md={3}>
                                    <Typography sx={{ fontWeight: 500, mb: 0.75 }}>Driver</Typography>
                                    <TextField
                                        select
                                        fullWidth
                                        // label="Driver"
                                        value={form.driver}
                                        onChange={(e) => handleChange("driver", e.target.value)}
                                        sx={textFieldSx}
                                    >
                                        {datas?.driver?.map((driver, inx) => (
                                            <MenuItem key={inx} value={driver?.label}>
                                                {driver?.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* CTA Button */}
                        <Stack flexDirection={"row"} justifyContent={"space-between"}>
                            <CtaButton label="Back" iconPosition="start" onClick={() => setStep("option")} variant="secondary" sx={{ boxShadow: "none !important" }} endIconSrc="/img/header/VectorLeft.svg" />
                            <CtaButton
                                label="Check Profit & ROI"
                                // onClick={() => onSubmit(form)}
                                onClick={() => handleSubmit()}
                            />
                        </Stack>
                    </>
                )}

                {step === "result" && (
                    <>
                        {/* Result view */}
                        <Typography className="jura" sx={{ fontWeight: 800, fontSize: 22, textAlign: "center", mb: 1 }}>
                            Congratulations! Your car is Eligible.
                        </Typography>
                        <Typography sx={{ fontSize: 15, textAlign: "center", color: "text.secondary", mb: 3 }}>
                            Enter information below to continue
                        </Typography>

                        {/* ROI Table */}
                        {/* Outer wrapper (for CTA alignment) */}
                        <Box sx={{ position: "relative", maxWidth: { sm: 560, md: 670, lg: 1100 }, mx: "auto" }}>
                            {/* Inner frame that ONLY contains the table and its adornments */}
                            <Box sx={{ position: "relative", width: "100%", display: "block" }}>
                                {/* Table card */}
                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        overflow: "hidden",
                                        borderRadius: "28px",
                                        boxShadow: "none",
                                        border: `1px solid ${borderColor}`,
                                        bgcolor: "#fff",
                                    }}
                                >
                                    <Table
                                        sx={{
                                            minWidth: 360,
                                            tableLayout: "fixed",
                                            "& th, & td": {
                                                p: { xs: 2, md: "12px", lg: "12px" },
                                                borderBottom: `1px solid ${borderColor}`,
                                                verticalAlign: "middle",
                                            },
                                            "& tbody tr:last-of-type td": { borderBottom: "none" },
                                        }}
                                    >
                                        <TableHead>
                                            <TableRow
                                                sx={{
                                                    "& th": {
                                                        fontWeight: 700,
                                                        fontSize: { xs: 15, md: 14 },
                                                        color: "#111",
                                                    },
                                                }}
                                            >
                                                <TableCell width="48%">Item</TableCell>
                                                <TableCell
                                                    width="26%"
                                                    align="center"
                                                    sx={{
                                                        borderLeft: `1px solid ${borderColor}`,
                                                        borderRight: `1px solid ${borderColor}`,
                                                    }}
                                                >
                                                    Monthly ROI Range (AED)
                                                </TableCell>
                                                <TableCell width="26%" align="center">
                                                    Annual ROI Potential
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {rows?.map((r, i) => (
                                                <TableRow key={i}>
                                                    <TableCell>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: 14, md: 14 },
                                                                color: "#111",
                                                                whiteSpace: "pre-line",
                                                                lineHeight: 1.3,
                                                            }}
                                                        >
                                                            {r.item}
                                                        </Typography>
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            borderLeft: `1px solid ${borderColor}`,
                                                            borderRight: `1px solid ${borderColor}`,
                                                            fontSize: { xs: 14, md: 14 },
                                                            fontWeight: 400,
                                                            color: "#111",
                                                        }}
                                                    >
                                                        {r.monthly}
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        sx={{
                                                            fontSize: { xs: 14, md: 14 },
                                                            fontWeight: 400,
                                                            color: "#111",
                                                        }}
                                                    >
                                                        {r.annual}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                                {/* Side notches (half-circles) */}
                                {/* Left notch */}
                                <Box
                                    aria-hidden
                                    sx={{
                                        position: "absolute",
                                        left: -10, // half of width
                                        top: 62,   // align with row divider
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        bgcolor: "#fff",                  // same as modal bg
                                        border: `1px solid ${borderColor}`,
                                        clipPath: "inset(0 0 0 50%)",     // keep right half (outer curve)
                                        zIndex: 2,
                                        pointerEvents: "none",
                                    }}
                                />

                                {/* Right notch */}
                                <Box
                                    aria-hidden
                                    sx={{
                                        position: "absolute",
                                        right: -10,
                                        top: 62,
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%",
                                        bgcolor: "#fff",
                                        border: `1px solid ${borderColor}`,
                                        clipPath: "inset(0 50% 0 0)",     // keep left half (outer curve)
                                        zIndex: 2,
                                        pointerEvents: "none",
                                    }}
                                />

                            </Box>
                        </Box>

                        {/* Buttons */}
                        <Stack direction="row" justifyContent="space-between" mt={3}>
                            <CtaButton label="Back" iconPosition="start" onClick={() => setStep("form")} variant="secondary" sx={{ boxShadow: "none !important" }} endIconSrc="/img/header/VectorLeft.svg" />
                            <Box display={"flex"} gap={4}>
                                <CtaButton label="Book a Call" onClick={() => window.open(process.env.BOOK_A_CALL, "_blank")} />
                                <DynamicPillButton
                                    label="Send a message"
                                    icon="/img/header/whatsapp.svg"
                                    iconPosition="end"
                                    bg="#25D366"
                                    onClick={() => {
                                        openWhatsAppChatForTravelAndTourism(form, getLabel())
                                    }}
                                    sx={{ height: "47px" }}
                                />
                            </Box>
                        </Stack>
                    </>
                )}

            </Box>
        </Modal>
    );
}
